import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/lib/api";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await auth.login(email.trim(), password);
      nav("/", { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.detail || "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="brand-mark">UZ</div>
        <h1>URL-Zentrale</h1>
        <p className="subtitle">Privates Dashboard • Anmeldung</p>
        <form onSubmit={submit}>
          {err && <div className="err" data-testid="login-error">{err}</div>}
          <div className="field">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              data-testid="login-email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="deine@email.de"
            />
          </div>
          <div className="field">
            <label htmlFor="login-password">Passwort</label>
            <input
              id="login-password"
              data-testid="login-password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            className="btn btn-gold"
            data-testid="login-submit"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? "Anmelden …" : "Anmelden"}
          </button>
        </form>
        <div className="login-foot">URL-ZENTRALE • PRIVATE</div>
      </div>
    </div>
  );
}
